import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createPlaylist, addTracksToPlaylist, removeTracksFromPlaylist } from '../lib/spotify';

export const usePlaylistManagement = () => {
  const queryClient = useQueryClient();

  const createNewPlaylist = useMutation({
    mutationFn: ({ name, description }: { name: string; description?: string }) =>
      createPlaylist(name, description),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['playlists'] });
    },
  });

  const addTracks = useMutation({
    mutationFn: ({ playlistId, trackUris }: { playlistId: string; trackUris: string[] }) =>
      addTracksToPlaylist(playlistId, trackUris),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['playlists'] });
    },
  });

  const removeTracks = useMutation({
    mutationFn: ({ playlistId, trackUris }: { playlistId: string; trackUris: string[] }) =>
      removeTracksFromPlaylist(playlistId, trackUris),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['playlists'] });
    },
  });

  return {
    createNewPlaylist,
    addTracks,
    removeTracks,
  };
};